import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const postStartBreak = async (payload) => {
  const { data } = await SigliveServiceSSE({
    method: 'POST',
    url: `/monitoring-operator/break/start`,
    data: payload,
  });

  return data?.data;
};

export default postStartBreak;
